import { render, staticRenderFns } from "./SupplierContacts.vue?vue&type=template&id=64f2b3e8&scoped=true&"
import script from "./SupplierContacts.vue?vue&type=script&lang=js&"
export * from "./SupplierContacts.vue?vue&type=script&lang=js&"
import style0 from "./SupplierContacts.vue?vue&type=style&index=0&id=64f2b3e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f2b3e8",
  null
  
)

export default component.exports